import { appConfig as $config } from '../../app.config';
import { fUploader } from '../fUploader';
import { ValidationRules } from '../ValidationRules';

export const addFileDialog = (function () {
  let $fup = null;
  let dialogInstance;

  let mapping = {
    mockupOut: (data) => {
      return {
        color: data.color,
        fileSrc: data.fileSrc,
        fileType: data.imageType * 1,
        fileTypeName: data.imageTypeName,
        isMainImage: !!data.isMainImage,
        isUploadToStore: !!data.isUploadToStore,
        isHidden: false,
        isUplading: false,
        file: {
          fileName: data.fileName,
          fileStorageName: data.fileStorageName,
          fileType: data.fileFileType * 1,
          uri: data.uri
        },
        externalFileType: isNaN(Number(data.mockupType)) ? 1 : Number(data.mockupType),
        fileTypeDisplayName: data.imageTypeName,
        externalFileDisplayTypeName: data.mockupTypeName,
        canRemove: true
      };
    },
    printOut: (data) => {
      return {
        index: data.index,
        sizeRange: data.size,
        sizes: [data.size],
        canvasSizeWidth: data.canvasSizeWidth,
        canvasSizeHeight: data.canvasSizeHeight,
        canvasLocation: data.canvasLocation,
        alignment: data.alignment,
        areaType: data.areaType,
        checked: false,
        isHidden: false,
        isCustomRow: true,
        isCurrentlyAdded: true,
        alignmentIsValid: true,
        areaTypeIsValid: true,
        file: {
          fileName: data.fileName,
          fileStorageName: data.fileStorageName,
          fileType: data.fileFileType * 1,
          uri: data.uri
        }
      };
    }
  };

  let mockup = ({ data = {}, ok = () => {} }) => {
    close();

    let template = require('./tmpl/dialog/mockup-file.hbs');

    dialogInstance = bootbox
      .dialog({
        title: $lang.MasterProductData.MockupFilesGroup.AddMockupModal.Title
          .replace('{{areaType}}', data.element.areaTypeDisplayName),
        message: template(data),
        size: 'xl',
        className: 'modal-scrolled-content mpd-addnewfile-modal-dialog',
        buttons: {
          Ok: {
            label: `${$lang.btn.save}`,
            className: 'btn btn-brand',
            callback: (e) => {
              let $form = $('#addnewMPDfileform');
              // Validate
              $form.validate({ rules: ValidationRules.mpdAddMockupDialog });
              if (!$form.valid()) {
                $('.form-control.is-invalid').focus();
                return false;
              }

              ok(mapping.mockupOut($form.serializeObject()));

              return false;
            }
          },
          Close: {
            label: `${$lang.btn.cancel}`,
            className: 'btn btn-link'
          }
        }
      });

    dialogInstance.init(init.bind(null, data));
  };

  let close = () => {
    if (!dialogInstance) {
      return;
    }

    dialogInstance.modal('hide');
    dialogInstance = null;
  };

  let printfile = ({ data = {}, ok = () => {} }) => {
    if (data.element && data.element.length) {
      data.index = data.element.length;
    }

    let template = require('./tmpl/dialog/print-file.hbs');

    dialog({
      title: $lang.MasterProductData.ProductionDataTab.AddPrintFile,
      message: template(data),
      callback: (e) => {
        let $form = $('#addnewMPDfileform');
        // Validate
        $form.validate({ rules: ValidationRules.mpdAddPrintfileDialog });
        if (!$form.valid()) {
          $('.form-control.is-invalid').focus();
          return false;
        }
        ok(mapping.printOut($form.serializeObject()));
      }
    }, data);
  };

  let dialog = ({ title: title, message: message, callback: callback }, data) => {
    bootbox
      .dialog({
        title: title,
        message: message,
        size: 'large',
        className: 'modal-scrolled-content mpd-addnewfile-modal-dialog',
        buttons: {
          Ok: {
            label: `<i class="fal fa-save"></i> ${$lang.btn.save}`,
            className: 'btn btn-brand',
            callback: callback
          },
          Close: {
            label: `<i class="fal fa-times"></i> ${$lang.btn.cancel}`,
            className: 'btn btn-link'
          }
        }
      })
      .init(init.bind(null, data));
  };

  let init = (data) => {
    let $form = $('#addnewMPDfileform');

    subscribeToMockupTypeSwitch($form, data);
    subscribeToFileExtensionSwitch($form);
    subscribeToImageTypeSwitch($form);
    subscribeToCheckboxChange($form);

    $('.form-control-select2', $form).select2();
  };

  let subscribeToMockupTypeSwitch = ($form, data) => {
    const $_mockupType = $('select[name="mockupType"]', $form);

    if (!$_mockupType.length) {
      return;
    }

    $_mockupType.select2().on('change', (e) => {
      let $_mockupTypeName = $('input[name="mockupTypeName"]', $form);
      if ($_mockupTypeName.length) {
        $_mockupTypeName.val($(e.target).find(':selected').text());
      }

      let $_isUploadToStore = $('[name="isUploadToStore"]', $form);
      let $_isMainImage = $('[name="isMainImage"]', $form);

      const selectedMockupType = data?.element?.availableExternalFileTypes?.find((t) => String(t.type) === $(e.target).val());
      if (selectedMockupType?.setUploadToStore) {
        $_isUploadToStore.prop({ checked: true });
        $_isMainImage.prop({ checked: false });
      } else {
        $_isUploadToStore.prop({ checked: false });
        $_isMainImage.prop({ checked: false, disabled: true });
      }
    }).trigger('change');
  };

  let subscribeToFileExtensionSwitch = ($form) => {
    let $_fileExtension = $('select[name="fileExtension"]', $form);
    let $_imageType = $('select[name="imageType"]', $form);

    if ($_fileExtension.length) {
      $_fileExtension.select2().on('change', (e) => {
        const $form = $('#addnewMPDfileform');
        let extensions = $(e.target).val();

        let $_fileExtensionName = $('input[name="fileExtensionName"]', $form);
        if ($_fileExtensionName.length) {
          $_fileExtensionName.val($(e.target).find(':selected').text());
        }

        fileUploaderInit(extensions, $_imageType.val());
      }).trigger('change');
    } else {
      fileUploaderInit();
    }
  };

  let subscribeToImageTypeSwitch = ($form) => {
    let $_imageType = $('select[name="imageType"]', $form);
    let $_fileExtension = $('select[name="fileExtension"]', $form);

    if ($_imageType.length) {
      $_imageType.select2().on('change', (e) => {
        const $form = $('#addnewMPDfileform');
        let fileType = $(e.target).val();

        let $_imageTypeName = $('input[name="imageTypeName"]', $form);
        if ($_imageTypeName.length) {
          $_imageTypeName.val($(e.target).find(':selected').text());
        }

        fileUploaderInit($_fileExtension.val(), fileType);
      }).trigger('change');
    } else {
      fileUploaderInit();
    }
  };

  let subscribeToCheckboxChange = ($form) => {
    let $_isUploadToStore = $('[name="isUploadToStore"]', $form);
    let $_isMainImage = $('[name="isMainImage"]', $form);

    $_isUploadToStore.on('change', () => {
      if (!$_isUploadToStore.prop('checked')) {
        $_isMainImage.prop({ disabled: true, checked: false });
      } else {
        $_isMainImage.prop({ disabled: false });
      }
    });
  };

  let fileUploaderInit = (fileExtensions, fileType) => {
    const options = (!fileExtensions || !fileType) ? $config.filesModel['1'] : {
      extensions: fileExtensions?.replace(/\./g, '').replace(/\s/g, '').split(',') || [],
      fileType: isNaN(Number(fileType)) ? 1 : Number(fileType)
    };

    $fup = new fUploader('input[type="file"]', {
      ...options,
      ...{
        autostart: true,
        pageType: 'MasterProductDataRow',
        blockEl: '.mpd-addnewfile-modal-dialog .modal-content',
        complete: uploadComplete
      }
    });
  };

  let uploadComplete = (data) => {
    let $form = $('#addnewMPDfileform');
    if (!data.length) {
      $('select[name="fileType"]', $form).trigger('change');
      return alert('Error occured');
    }
    data = data[0];
    if (data.reader && data.reader.src) {
      $('input[name="fileSrc"]', $form).val(data.reader.src);
    }
    $('input[name="fileName"]', $form).val(data.fileName);
    $('input[name="uri"]', $form).val(data.uri);
    $('input[name="fileStorageName"]', $form).val(data.fileStorageName);
    $('input[name="fileFileType"]', $form).val(data.fileType);
  };

  return {
    mockup,
    close,
    printfile
  };
})();
